import { render } from "./ReleaseTerminal.vue?vue&type=template&id=26923777"
import script from "./ReleaseTerminal.vue?vue&type=script&lang=js"
export * from "./ReleaseTerminal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__